import _extends from "@babel/runtime/helpers/extends";
import React, { useImperativeHandle } from 'react';
import { useGeolocationControl } from './useGeolocationControl';
export * from './useGeolocationControl';
export default /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
    geolocationControl
  } = useGeolocationControl(props);
  useImperativeHandle(ref, () => _extends({}, props, {
    geolocationControl
  }), [geolocationControl, props]);
  return null;
});